import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id 8031577D-2528-4278-9F7B-93BD5DED18E3
 * name email-alert
 * version: 1.8.36
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/email-alert.svg
 * tags
 * - Alert / Error 
 */
export const EmailAlertIcon = createSvgIcon(<><path d="M18 8L10 13L2 8V6L10 11L18 6M18 4H2C.9 4 0 4.9 0 6V18C0 19.1 .9 20 2 20H18C19.1 20 20 19.1 20 18V6C20 4.9 19.1 4 18 4M24 7H22V13H24V7M24 15H22V17H24V15Z" /></>, 'EmailAlertIcon');
export default EmailAlertIcon